import { QuillModules, QuillToolbarConfig } from 'ngx-quill';

export const qullToolbar:
  | QuillToolbarConfig
  | string
  | {
      container?: string | string[] | QuillToolbarConfig;
      handlers?: {
        [key: string]: any;
      };
    }
  | boolean = {
  container: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ 'font': [] }],
    ['bold', 'italic', 'underline', 'strike'], // toggled buttons

    
    //[{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
    //[{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
    

    [{align: ''}, {align: 'center'}, {align: 'right'}],

    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ color: [] }],
    

    ['clean'], // remove formatting button

    ['link'],
    ['image']
    //['link', 'image', 'video']
  ],
};
export const quillConfig: QuillModules = {
  //toolbar: '.toolbar',
  toolbar: qullToolbar,
  'emoji-toolbar': true,
  'emoji-textarea': false,
  'emoji-shortname': false,
  QuillMarkdown: {
    ignoreTags: ['pre', 'strikethrough'], // @option - if you need to ignore some tags.

    tags: {
      // @option if you need to change for trigger pattern for some tags.
      blockquote: {
        pattern: /^(\|){1,6}\s/g,
      },
      bold: {
        pattern: /^(\|){1,6}\s/g,
      },
      italic: {
        pattern: /(\_){1}(.+?)(?:\1){1}/g,
      },
    },
  },
  keyboard: {
    bindings: {
      enter: {
        key: 13,
        handler: (range, context) => {
          return true;
        },
      },
    },
  },
};
